export default __webpack_public_path__ + "static/ml-banner-477e043be1998d8a33f0669aebfce130.webp";